import React, { useEffect, useState } from 'react';
import { Content, PageHeader, Tab, TabList, Tabs, TabContent, Spinner, AlertBar } from 'scorer-ui-kit';
import { useTranslation } from 'react-i18next';
import { PageHeaderContainer, DeviceNameLabel, Divider, NoteLabel, CenterAlignedContainer, SpinnerDesign } from '../Style';
import { useDevice } from '../hooks/useDevice';
import styled from 'styled-components';
import SnmpSettings from './SnmpSettings';
import EmailSettings from './EmailSettings';
import { useLocation } from 'react-router-dom';

const TabRow = styled.div`
  display: flex;
`;

const TabContentComponent = styled(TabContent)`
  margin-top: 20px;
`;

const NotificationSettings: React.FC = () => {
  const { state: { device, status_code, deviceLoading }, actions: { fetchDevice } } = useDevice();
  const { t } = useTranslation(['EmailSettings', 'Common']);
  const [alert, setAlert] = useState<{ key: any, message: string, type: 'success' | 'error' | 'warning' | 'info' | undefined }>({ key: new Date(), message: '', type: undefined });
  const location = useLocation();

  useEffect(() => {
    if (!deviceLoading) {
      if (status_code === '2') {
        setAlert({ key: new Date(), message: t('Common:deviceNotFound'), type: 'info' });
      }
    }
  }, [device, status_code, deviceLoading, t]);

  useEffect(() => {
    fetchDevice();
  }, [fetchDevice]);

  useEffect(() => {
    sessionStorage.removeItem('cameraTab');
    sessionStorage.removeItem('auditLogTab');
  }, [location]);

  return (
    <Content>
      <PageHeaderContainer>
        <PageHeader
          title={t('Common:notification')}
          icon='Notifications'
          areaTitle={t('Common:home')}
          areaHref='/'
        />
        <DeviceNameLabel htmlFor='' labelText={device.name} />
        <NoteLabel htmlFor='' labelText={device.detail} />
      </PageHeaderContainer>
      {
        (deviceLoading) ?
          <CenterAlignedContainer>
           <Spinner size='large' styling={SpinnerDesign} /> 
          </CenterAlignedContainer> :
          (alert.message !== '' ? 
            <AlertBar key={alert.key} type={alert.type} message={alert.message} /> :
            <Tabs>
              <TabList defaultTabId={sessionStorage.getItem('notificatioinTab') || 'emailSettings'}>
                <TabRow>
                  <Tab tabFor='emailSettings' onClick={()=>sessionStorage.setItem('notificatioinTab','emailSettings')}>{t('email')}</Tab>
                  <Tab tabFor='snmpSettings'  onClick={()=>sessionStorage.setItem('notificatioinTab','snmpSettings')}>{t('SNMP')}</Tab>
                </TabRow>
              </TabList>
              <Divider />
              <TabContentComponent tabId='emailSettings'>
                <EmailSettings />
              </TabContentComponent>
              <TabContentComponent tabId='snmpSettings'>
                <SnmpSettings />
              </TabContentComponent>
            </Tabs>
          )
      }
    </Content>
  );
};

export default NotificationSettings;
